import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api_urls } from "../../utilities";
import { getService, postService } from "../services";

export const fetchNotifications = createAsyncThunk(
  "notification/fetchAll",
  async (_, { getState, rejectWithValue }) => {
    if (getState().auth?.portal !== "admin") return [];
    try {
      const res = await getService(api_urls.notifications, {});
      const envelope = res.data ?? {};
      return envelope.data ?? [];
    } catch (err) {
      return rejectWithValue(err?.data ?? { message: err?.message });
    }
  }
);

export const fetchUnreadCount = createAsyncThunk(
  "notification/fetchUnreadCount",
  async (_, { getState, rejectWithValue }) => {
    if (getState().auth?.portal !== "admin") return 0;
    try {
      const res = await getService(api_urls.getUnreadCount, {});
      const envelope = res.data ?? {};
      return envelope.data?.count ?? envelope.data ?? envelope.count ?? 0;
    } catch (err) {
      return rejectWithValue(err?.data ?? { message: err?.message });
    }
  }
);

export const markAllRead = createAsyncThunk(
  "notification/markAllRead",
  async (_, { getState, dispatch, rejectWithValue }) => {
    if (getState().auth?.portal !== "admin") return;
    try {
      await postService(api_urls.markAllRead, {});
      dispatch(fetchNotifications());
      dispatch(fetchUnreadCount());
    } catch (err) {
      return rejectWithValue(err?.data ?? { message: err?.message });
    }
  }
);

export const markSingleRead = createAsyncThunk(
  "notification/markSingleRead",
  async (id, { getState, dispatch, rejectWithValue }) => {
    if (getState().auth?.portal !== "admin") return;
    try {
      await postService(api_urls.markSingleRead(id), {});
      dispatch(fetchNotifications());
      dispatch(fetchUnreadCount());
    } catch (err) {
      return rejectWithValue(err?.data ?? { message: err?.message });
    }
  }
);

const initialState = {
  list: [],
  unreadCount: 0,
  loading: false,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNotifications.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.list = Array.isArray(payload) ? payload : [];
      })
      .addCase(fetchNotifications.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchUnreadCount.fulfilled, (state, { payload }) => {
        state.unreadCount = typeof payload === "number" ? payload : 0;
      });
  },
});

export default notificationSlice.reducer;
